import createRequestBody from "../utils/createRequestBody";

const  _query = async (url, token, method, requestBody) => {
  try {
    method = method || "GET"
    let body = createRequestBody(method, token, requestBody);
  
    return fetch(url, body);
  }
  catch(err) {
    console.log("this is the error", err);
    return err;
  }
};

export default  _query;
